import script from "./LockSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./LockSummary.vue?vue&type=script&setup=true&lang=ts"

import "./LockSummary.vue?vue&type=style&index=0&id=70a6d7db&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a6d7db"]])

export default __exports__